import "../App.css";
import { useState, useEffect } from "react";

const Concerns66 = () => {
  const [concernsData, setConcernsData] = useState({});

  useEffect(() => {
    fetch("https://s3.eu-west-2.amazonaws.com/gym66.assets/concerns.json")
      .then((response) => response.json())
      .then((data) => {
        //discard duplicates based on client_id, keeping the first occurrence
        data.expiring_memberships = data.expiring_memberships.filter(
          (member, index, self) =>
            index === self.findIndex((m) => m.client_id === member.client_id)
        );
        data.inactive_members = data.inactive_members.filter(
          (member, index, self) =>
            index === self.findIndex((m) => m.client_id === member.client_id)
        );
        //sort by days_since_last_attendance ascending
        data.inactive_members.sort(
          (a, b) => a.days_since_last_attendance - b.days_since_last_attendance
        );
        setConcernsData(data);
      });
  }, []);

  const renderExpiringMembershipsTable = () => {
    if (!concernsData.expiring_memberships) {
      return <p>Loading...</p>;
    }
    return (
      <table className="pretty-table">
        <thead>
          <tr>
            {/* <th>Member ID</th> */}
            <th>Name</th>
            <th>Membership Type</th>
          </tr>
        </thead>
        <tbody>
          {concernsData.expiring_memberships.map((member) => (
            <tr key={member.client_id}>
              {/* <td>{member.client_id}</td> */}
              <td>{member.name}</td>
              <td>{member.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const renderLowAttendanceTable = () => {
    if (!concernsData.inactive_members) {
      return <p>Loading...</p>;
    }
    return (
      <table className="pretty-table">
        <thead>
          <tr>
            {/* <th>Member ID</th> */}
            <th>Name</th>
            <th>Membership Type</th>
            <th>Days since last visit</th>
          </tr>
        </thead>
        <tbody>
          {concernsData.inactive_members
            .map((member) => (
              <tr key={member.client_id}>
                {/* <td>{member.client_id}</td> */}
                <td>{member.name}</td>
                <td>{member.type}</td>
                <td>{member.days_since_last_attendance}</td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="App">
      <h1>Gym 66 Concerns Dashboard</h1>
      <h2>Expiring Memberships</h2>
      {renderExpiringMembershipsTable()}
      <h2>Low Attendance</h2>
      {renderLowAttendanceTable()}
    </div>
  );
};

export default Concerns66;
